import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Achievements from '../components/Achievements';
import Education from '../components/Education';

const AchievementsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 bg-gradient-to-b from-teal-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Awards & Achievements
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Recognition for excellence in cancer care, research, and patient service
          </p>
        </div>
      </div>

      {/* Achievements Content */}
      <Achievements />

      {/* Education & Training */}
      <Education />

      {/* Additional Recognition */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Additional Recognition</h2>
          
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Academic Excellence</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• 1st in Division, Krishna District, SSC Examination - Merit Scholarship</li>
                <li>• Silver Jubilee Celebrations Gold Medal in Preventive Medicine, 2006</li>
                <li>• Independence Day Leadership Award, 2007, Andhra Medical College</li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Quiz Competition Excellence</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• 1st Prize - Interinstitutional Medical Oncology Quiz, C4-MAX, Delhi (2018)</li>
                <li>• 1st Prize - Oncology Quiz, Lung Cancer Updates, Ahmedabad (2018)</li>
                <li>• 1st Prize - Delhi Breast Oncology Group (DBOG) Quiz, Noida (2018)</li>
                <li>• Winner - Quiz Competition, RGCON Annual International Conference (2019)</li>
                <li>• 2nd Prize - MVRCON Annual International Conference, Calicut (2018)</li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Research Recognition</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• TYSA India Award Finalist - Winner of Zonal Round, Young Oncologist Scholarship (2018)</li>
                <li>• Certificate of Excellent Knowledge in Medicine - Princess Margaret Cancer Center</li>
                <li>• Multiple travel grants for international conferences and research visits</li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Editorial Roles</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Associate Editor - Asian Journal of Oncology</li>
                <li>• Associate Editor - Indian Journal of Medical and Pediatric Oncology</li>
                <li>• Assistant Editor - Oncology Journal of India</li>
                <li>• Reviewer for multiple international medical journals</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AchievementsPage;